module.exports = __webpack_public_path__ + "img/badges.372730ed.svg";